import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: "portfolio-site-3b042.firebaseapp.com",
  projectId: "portfolio-site-3b042",
  storageBucket: "portfolio-site-3b042.appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};

// Firebaseの初期化
export const firebaseApp = initializeApp(firebaseConfig);

// 認証の初期化
export const auth = getAuth(firebaseApp);
auth.useDeviceLanguage();

// Firestoreの初期化
export const db = getFirestore(firebaseApp);

if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8081);
} 